import React from 'react';
import './PageLoader.css';

/**
 * Lightweight first-paint placeholder shown while a route chunk is loading.
 * Gives immediate visual feedback instead of a blank white screen, which
 * improves perceived FCP and avoids the "nothing is happening" feeling.
 *
 * Deliberately cheap (no JS work, no fonts required) so it can render before
 * the route chunk and main bundle finish evaluating.
 */
const PageLoader: React.FC = () => (
  <div className="page-loader" aria-hidden="true">
    <div className="page-loader-bar" />
  </div>
);

export default PageLoader;
